export enum RatingSummaryDataGridItemType {
  Default = 'default',
  PrimaryTitle = 'mainTitle',
  SecondaryTitle = 'secondaryTitle',
}

export type RatingSummaryDataGridItem = {
  id: string;
  type: RatingSummaryDataGridItemType;
  title?: string;
  ratedPremium?: string;
  termFactor?: string;
  termPremium?: string;
  policyTermPremium?: string;
  policyTermFactor?: string;
  transactionTermFactor?: string;
  transactionTermPremium?: string;
};

export type RatingModalType = 'Rating Report' | 'Premium Details';

export const RatingModalTypes = {
  RatingReport: 'Rating Report' as RatingModalType,
  PremiumDetails: 'Premium Details' as RatingModalType,
};

export const marginTop = {
  [RatingSummaryDataGridItemType.Default]: '0',
  [RatingSummaryDataGridItemType.PrimaryTitle]: '8px',
  [RatingSummaryDataGridItemType.SecondaryTitle]: '4px',
};

export const marginLeft = {
  [RatingSummaryDataGridItemType.Default]: '48px',
  [RatingSummaryDataGridItemType.PrimaryTitle]: '16px',
  [RatingSummaryDataGridItemType.SecondaryTitle]: '32px',
};
